import { LookupModelSearchEvent, LookupModelSelectionEvent, TableRow, Textbox } from "@mcleod/components";
import { AutogenLayoutMobileCommControlSendLoadListenerTable } from "./autogen/AutogenLayoutMobileCommControlSendLoadListenerTable";

export class MobileCommControlSendLoadListenerTable extends AutogenLayoutMobileCommControlSendLoadListenerTable {
    private static readonly VENDOR_CAT_ID_MAPPING: Record<string, string> = {
        "KEEPTRUCK": "KEEPTR",
        "SYMPHONY": "SYMPHONY",
        "SAMSARA": "SAMSARA"
    } as const;

    textboxTableNameOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const tableRow = TableRow.getContainingTableRow(event.target);
        const textboxDisplayName = tableRow.findComponentById("textboxDisplayName") as Textbox;

        tableRow.data.setValueAndLookupModelData("mc_dispatch_update_field_id", null, null);
        textboxDisplayName.displayData(tableRow.data, null, 0);
    }

    /**
     * Configure lookup model search parameters for table name selection
     */
    textboxTableNameBeforeLookupModelSearch(event: LookupModelSearchEvent): void {
        try {
            const mcControlId = this.getMcControlId();
            if (mcControlId) {
                event.filter.mc_control_id = mcControlId;
            }
        } catch (error) {
            console.error("Error in textboxTableNameBeforeLookupModelSearch:", error);
        }
    }

    /**
     * Configure lookup model search parameters for display name selection
     */
    textboxDisplayNameBeforeLookupModelSearch(event: LookupModelSearchEvent): void {
        try {
            const mcControlId = this.getMcControlId();
            const tableName = this.getSelectedTableName();
            const categoryId = this.getCategoryId(mcControlId);

            // Collect mc_dispatch_update_field_id values from all rows
            const mcDispatchUpdateFieldIds: string[] = [];
            if (this.tableMCSendLoadListener?.rows) {
                for (const row of this.tableMCSendLoadListener.rows) {
                    const fieldId = row.data?.get("mc_dispatch_update_field_id", "");
                    if (fieldId) {
                        mcDispatchUpdateFieldIds.push(fieldId);
                    }
                }
            }

            if (mcControlId && tableName) {
                event.filter.mc_control_id = mcControlId;
                event.filter.table_name = tableName;
                event.filter.category_id = categoryId;
                event.filter.excluded_ids = mcDispatchUpdateFieldIds;
            }
        } catch (error) {
            console.error("Error in textboxDisplayNameBeforeLookupModelSearch:", error);
        }
    }

    /**
     * Get the mobile comm control ID from parent layout
     */
    private getMcControlId(): string {
        return this.owner?.mainDataSource?.activeRow?.get("id", "") || "";
    }

    /**
     * Get the selected table name from the current row
     */
    private getSelectedTableName(): string {
        try {
            const quickAddRow = this.tableMCSendLoadListener?.quickAddRow;
            if (!quickAddRow) {
                return "";
            }

            const textboxTableName = quickAddRow.findComponentById("textboxTableName") as Textbox;
            let tableName = textboxTableName?.text || "";

            // Remove trailing 'S' for specific table names
            if (tableName.toUpperCase() === "MOVEMENTS" || tableName.toUpperCase() === "STOPS") {
                tableName = tableName.slice(0, -1); // Remove last character (the 'S')
            }

            return tableName;
        } catch (error) {
            console.error("Error getting selected table name:", error);
            return "";
        }
    }

    /**
     * Map vendor ID to category ID using predefined mapping
     */
    private getCategoryId(vendorId: string): string {
        return MobileCommControlSendLoadListenerTable.VENDOR_CAT_ID_MAPPING[vendorId] || "";
    }
}
